import { render, staticRenderFns } from "./myLive.vue?vue&type=template&id=4e478fe3&scoped=true&"
import script from "./myLive.vue?vue&type=script&lang=js&"
export * from "./myLive.vue?vue&type=script&lang=js&"
import style0 from "./myLive.vue?vue&type=style&index=0&id=4e478fe3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e478fe3",
  null
  
)

export default component.exports